import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { INSIGHTS } from "@/data/insights";
import { InsightDialog } from "@/components/InsightDialog";

export default function Insights() {
  const [open, setOpen] = useState(null);

  return (
    <section id="insights" className="relative border-t border-white/5 py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <Reveal>
              <Eyebrow>Insights</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
                Thinking that <span className="text-accent">earns its place</span>
                <br />
                on the board agenda.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-slate-400 sm:text-base">
              Short, practical perspectives on governing AI, running transformation and securing the enterprise — written for the people accountable for the outcome.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px bg-white/10 lg:grid-cols-3">
          {INSIGHTS.map((a, i) => (
            <Reveal key={a.slug} delay={0.1 + i * 0.1} className="bg-ink">
              <button
                type="button"
                data-testid={`insight-card-${a.slug}`}
                onClick={() => setOpen(a)}
                className="group flex h-full w-full flex-col p-8 text-left transition-colors hover:bg-surface/60 lg:p-10"
              >
                <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                  <span>{a.category}</span>
                  <span className="text-slate-500">{a.readTime}</span>
                </div>
                <h3 className="mt-8 font-display text-xl leading-snug tracking-tight text-white sm:text-2xl">
                  {a.title}
                </h3>
                <p className="mt-6 flex-1 text-sm leading-relaxed text-slate-400">{a.excerpt}</p>
                <span className="mt-10 flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-300 transition-colors group-hover:text-gold">
                  Read the insight
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <InsightDialog article={open} onClose={() => setOpen(null)} />
    </section>
  );
}
